interface SpinnerProps {
  /** sm: satır içi · md: kart içi · lg: tam sayfa */
  size?: "sm" | "md" | "lg";
  label?: string;
  className?: string;
}

const SIZES: Record<NonNullable<SpinnerProps["size"]>, string> = {
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-2",
  lg: "h-10 w-10 border-4",
};

/** Yükleniyor göstergesi. Ekran okuyucu için metin her zaman vardır. */
export function Spinner({ size = "md", label = "Yükleniyor", className = "" }: SpinnerProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} role="status" aria-live="polite">
      <span
        aria-hidden="true"
        className={`${SIZES[size]} animate-spin rounded-full border-gray-300 border-t-primary-600`}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}

/** Sayfa/panel ortasında ortalanmış yükleniyor bloğu. */
export function LoadingBlock({ label = "Yükleniyor" }: { label?: string }) {
  return (
    <div className="space-y-3 py-6" role="status" aria-live="polite">
      <span className="sr-only">{label}…</span>
      {/* İskelet: içerik gelmeden sayfanın biçimini gösterir — boş beyaz alan yerine. */}
      <div aria-hidden="true" className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-24 animate-pulse rounded-xl bg-gray-200/60" />
        ))}
      </div>
      <div aria-hidden="true" className="h-48 animate-pulse rounded-xl bg-gray-200/50" />
      <p aria-hidden="true" className="text-center text-xs text-gray-400">{label}…</p>
    </div>
  );
}

export default Spinner;
